import $ from 'jquery'

export default class pageIndex {
  constructor (element) {
    this.$element = $(element)
  }
}
